export default __webpack_public_path__ + "static/media/B72.e6074bee.png";